import React from 'react'

export interface PageContextType {
  pageId: string
  slug: string
  isPreview?: boolean
  isSectionScrollTrackingEnabled?: boolean
}

export const PageContext = React.createContext<PageContextType>({
  pageId: 'unknown',
  slug: 'unknown',
  isPreview: false,
  isSectionScrollTrackingEnabled: false,
})
